import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text, Box } from 'pcln-design-system'
import styled from 'styled-components'
import MessageSystem from '../MessageSystem'
import { Close, Icon } from 'pcln-icons'

const propTypes = {
  animationDelay: PropTypes.string,
  animationStickinessDelay: PropTypes.string,
  bottom: PropTypes.bool,
  handleCloseClick: PropTypes.func,
  iconColor: PropTypes.string,
  iconName: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageUrl: PropTypes.string,
  leftBarColor: PropTypes.string,
  renderDynamicContent: PropTypes.func,
  renderHeaderContent: PropTypes.func,
}

const defaultProps = {
  bottom: false,
  iconColor: 'primary.base',
  iconSize: 24,
}

const CursorClose = styled(Close)`
  cursor: pointer;
`

const IconBox = styled(Box)`
  height: 32px;
`

const NotificationIcon = ({
  animationDelay,
  animationStickinessDelay,
  bottom,
  handleCloseClick,
  iconColor,
  iconName,
  iconSize,
  leftBarColor,
  renderDynamicContent,
  renderHeaderContent,
}) => {
  const props = {
    bottom,
    leftBarColor,
    animationDelay,
    animationStickinessDelay,
    messageComponent: (
      <Flex pb={2}>
        <Box width={iconSize} m={1}>
          <Icon color={iconColor} size={iconSize} name={iconName} />
        </Box>
        <Flex flexDirection='column'>
          <Flex justifyContent='space-between'>
            <Text fontSize={[1, 2]} lineHeight='24px' ml={2} mr={1} my={1}>
              {renderHeaderContent && renderHeaderContent()}
            </Text>
            <IconBox width={32} p={1}>
              <CursorClose
                data-unit-id='NOTIFICATION_CLOSE'
                onClick={handleCloseClick}
                color='text.dark'
                size={24}
              />
            </IconBox>
          </Flex>
          <Text fontSize={[0, 1]} mt={[0, 1]} mr={1} mb={[0, 1]} ml={2}>
            {renderDynamicContent && renderDynamicContent()}
          </Text>
        </Flex>
      </Flex>
    ),
  }
  return <MessageSystem {...props} />
}

NotificationIcon.propTypes = propTypes
NotificationIcon.defaultProps = defaultProps
export default NotificationIcon
